// extracted by mini-css-extract-plugin
export default {"label":"Checkbox_label__FJ32w","checkmark":"Checkbox_checkmark__CDNBX"};